export default "__VITE_ASSET__BnHJohfl__"